import { takeEvery, call, put } from "redux-saga/effects";
import { GET_EMP_FORMPOST, SET_EMP_FORMPOST } from "../actions";
import empApi from "../utils/employeeAxios";
export const watchGetEmpFormPost = function* () {
  yield takeEvery(GET_EMP_FORMPOST, workerGetEmpFormPost);
};

function* workerGetEmpFormPost({ formPayload, postUrl, method }) {
  try {
    const result = yield call(getEmpFormPost, formPayload, postUrl, method);
    yield put({ type: SET_EMP_FORMPOST, value: [result.data] });
  } catch (e) {
    console.log(e, postUrl + " post failed");
    const returnerror = [];
    returnerror.push(e?.response?.data || []);
    yield put({ type: SET_EMP_FORMPOST, value: returnerror });
  }
}

function getEmpFormPost(formPayload, postUrl, method = "post") {
  const requestMethod = method === "update" ? "put" : "post";
  return empApi[requestMethod](postUrl, formPayload);
}
